import { render } from "./CrTag.vue?vue&type=template&id=acfbb7c4&scoped=true"
import script from "./CrTag.vue?vue&type=script&lang=js"
export * from "./CrTag.vue?vue&type=script&lang=js"

import "./CrTag.vue?vue&type=style&index=0&id=acfbb7c4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acfbb7c4"]])

export default __exports__